import { render } from "./Hello_World.vue?vue&type=template&id=123ae93a&scoped=true"
import script from "./Hello_World.vue?vue&type=script&lang=js"
export * from "./Hello_World.vue?vue&type=script&lang=js"

import "./Hello_World.vue?vue&type=style&index=0&id=123ae93a&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123ae93a"]])

export default __exports__